import React from 'react';
import CSSModules from 'react-css-modules';
import style from './h2.scss';

const H2 = props => (
  <h2 styleName={`root ${process.muhimma.indexOf(process.target[0]) !== -1 ? 'muhimma' : ''}`}>
    {props.children}
  </h2>
);

export default CSSModules(H2, style, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/h2.js